import React from "react";
import { connect } from "react-redux";
import Map from "../sharedComponents/Map";
import BuildingLayer from "../../../pages/ExplorerPage/Map/BuildingLayer";
import { pdfSelectors } from "../../../../state/pdf";
import Pdf from "../../../../types/Pdf";
import { MapStyleProperties } from "../../../../utils/mapbox/mapStyleProperties";

const mapStateToProps = (state) => {
  return {
    camera: pdfSelectors.getCamera(state),
  };
}

type StateProps = ReturnType<typeof mapStateToProps>;
type Props = StateProps;

class MapBuilding extends React.PureComponent<Props, {}> {
  render() {
    return (
      <Map
        pdfImageType={Pdf.ImageType.Building}
        camera={this.props.camera}
        mapStyleUrl={MapStyleProperties.StyleUrl.Streets}
      >
        <BuildingLayer />
      </Map>
    )
  }
}

export default connect(
  mapStateToProps,
)(MapBuilding);
